export const en = {
   cart: {
    summary: {
      coupons: {
        title: 'Insert discount code',
      },
    },
  },

  misc: {
    product: {
      color: 'Color',
      shippingDescription: 'Estimated shipping within {{shippingDescription}}',
      size: 'Size',
    },
    storeName: 'Yes Zee'
  },
  product: {
    selectSize: 'Select a size',
    size: 'Size',
  },
  welcome: 'Welcome to Essenza',
};
